export default __webpack_public_path__ + "static/media/next.836aff49.svg";